import React, { Component } from "react";
import { connect } from "react-redux";

import json2csv from "json2csv";
import Loading from "./../components/popups/loading.jsx";
import MerchantRateRow from "./../components/bulk/merchantRateRow.jsx";
import {
  sortNumsAsc,
  sortNumsDesc,
  sortAlphaAsc,
  sortAlphaDesc,
} from "./../utils/sort";
import { defaultAction } from "./../actions/defaultAction.js";
import * as ActionTypes from "./../constants/actionTypes";
import { score } from "ccui-framework";
import { HeadLine } from "../modules/HeadLine";
import styled from "@emotion/styled";

const DownloadLink = styled.a`
  background: #ffffff;
  border-radius: 80px;
  font-family: Montserrat, serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  text-align: center;
  color: #c7a878;
  border: 1px solid rgba(199, 168, 120, 0.32);
  height: 40px;
  width: 200px;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    color: #c7a878;
    text-decoration: none;
    transform: translateY(-0.5px);
    border-color: #b37b28;
  }
`;

class CurrentRates extends Component {
  componentDidMount() {
    const { setSortOrder, setFieldToSort } = this.props;
    setSortOrder("asc");
    setFieldToSort("name");
  }

  componentWillUnmount() {
    const { clearSearchText, setSortOrder } = this.props;
    clearSearchText();
    setSortOrder("desc");
  }
  isSortableField = (fieldToSort) => {
    const { userActions } = this.props;
    const caretClasses =
      userActions.get("sortOrder") === "asc"
        ? "fa fa-lg fa-caret-up mar-l-10"
        : "fa fa-lg fa-caret-down mar-l-10";
    return (
      fieldToSort === userActions.get("fieldToSort") && (
        <i className={caretClasses}></i>
      )
    );
  };
  setSortOrderAndSortField = (fieldToSort) => {
    const { setSortOrder, setFieldToSort, userActions } = this.props;
    setFieldToSort(fieldToSort);
    userActions.get("sortOrder") === "asc"
      ? setSortOrder("desc")
      : setSortOrder("asc");
  };
  sortRows = (a, b) => {
    const { userActions } = this.props;
    const sortOrder = userActions.get("sortOrder");

    switch (userActions.get("fieldToSort")) {
      case "name":
        return sortOrder === "asc"
          ? sortAlphaAsc(a.name, b.name)
          : sortAlphaDesc(a.name, b.name);
      case "percentage":
        return sortOrder === "asc"
          ? sortNumsAsc(a.sellPercentage, b.sellPercentage)
          : sortNumsDesc(a.sellPercentage, b.sellPercentage);
      case "max_card_value":
        return sortOrder === "asc"
          ? sortNumsAsc(a.limit.max, b.limit.max)
          : sortNumsDesc(a.limit.max, b.limit.max);
      case "submission_method":
        return sortOrder === "asc"
          ? sortAlphaAsc(a.submissionMethod, b.submissionMethod)
          : sortAlphaDesc(a.submissionMethod, b.submissionMethod);
      default:
        return sortOrder === "asc"
          ? sortNumsAsc(a.name, b.name)
          : sortNumsDesc(a.name, b.name);
    }
  };

  filterBySearch = ({
    id,
    sellPercentage,
    limit: { max },
    submissionMethod,
    ...merchant
  }) => {
    const { userActions } = this.props;

    return (
      score(merchant, userActions.get("searchText"), -1500) ||
      `${sellPercentage}% ${max} ${submissionMethod}`
        .toLowerCase()
        .indexOf(userActions.get("searchText").toLowerCase()) !== -1
    );
  };

  render() {
    const { merchantsSell, userInfo, updateSearchText } = this.props;

    if (userInfo.get("displayLoading") || !merchantsSell.length) {
      return <Loading showLoading />;
    }

    const merchantRateRows = merchantsSell
      .filter(this.filterBySearch)
      .sort(this.sortRows)
      .map((merchant) => <MerchantRateRow key={merchant.id} {...merchant} />);

    let csv;

    if (merchantsSell.length) {
      csv = json2csv({
        data: merchantsSell,
        fields: [
          { label: "id", value: "id" },
          { label: "name", value: "name" },
          { label: "percentage", value: "sellPercentage" },
          { label: "max_card_value", value: "limit.max" },
          { label: "submission method", value: "submissionMethod" },
        ],
      });
    }

    const tableHeight = window.innerHeight - 215;

    return (
      <div
        className="current-rates-container"
        style={{ flex: "80%", padding: "2rem" }}
      >
        <HeadLine
          headingText={"Rate Sheet"}
          tagLine={"Check what percentage of card’s value is paid out to you"}
        />
        <div
          className="search-container"
          style={{
            display: "flex",
            justifyContent: "flex-end",
            position: "relative",
            top: "-70px",
          }}
        >
          <div style={{ marginRight: "2rem" }}>
            <input
              className="activity-search-box pad-r-40"
              style={{
                background: "rgba(196, 196, 196, 0.14)",
                borderRadius: "80px",
                height: "40px",
                padding: "1rem",
              }}
              placeholder="Search Brands"
              onChange={updateSearchText}
            />
            <i className="fa fa-lg fa-search activity-search-icon"></i>
          </div>
          <DownloadLink
            href={`data:text/csv;charset=utf-8,${encodeURI(csv)}`}
            target="_blank"
            download="current_rates.csv"
            rel="noreferrer"
          >
            Download CSV
          </DownloadLink>
        </div>
        <div
          style={{
            marginTop: "-40px",
            height: tableHeight,
            overflowY: "scroll",
          }}
        >
          <table className="fixed-table">
            <thead>
              <tr>
                <th
                  className="panel-column pointer"
                  onClick={() => this.setSortOrderAndSortField("name")}
                >
                  Name {this.isSortableField("name")}
                </th>
                <th
                  className="panel-column pointer"
                  onClick={() => this.setSortOrderAndSortField("percentage")}
                >
                  Percentage {this.isSortableField("percentage")}
                </th>
                <th
                  className="panel-column pointer"
                  onClick={() =>
                    this.setSortOrderAndSortField("max_card_value")
                  }
                >
                  Max Card Value {this.isSortableField("max_card_value")}
                </th>
                <th
                  className="panel-column pointer"
                  onClick={() =>
                    this.setSortOrderAndSortField("submission_method")
                  }
                >
                  Submission Method {this.isSortableField("submission_method")}
                </th>
              </tr>
            </thead>
            <tbody>
              {merchantRateRows.length ? (
                merchantRateRows
              ) : (
                <tr>
                  <td colSpan="4">No Results Found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    merchantsSell: state.merchants,
    userInfo: state.userInfo,
    userActions: state.userActions,
    customerInfo: state.customerInfo,
  }),
  (dispatch) => ({
    updateSearchText: (e) =>
      dispatch(
        defaultAction(ActionTypes.SET_SEARCH_TEXT, e.target.value.trim())
      ),
    clearSearchText: () =>
      dispatch(defaultAction(ActionTypes.RESET_SEARCH_TEXT)),
    setFieldToSort: (v) =>
      dispatch(defaultAction(ActionTypes.SET_FIELD_TO_SORT, v)),
    setSortOrder: (v) => dispatch(defaultAction(ActionTypes.SET_SORT_ORDER, v)),
  })
)(CurrentRates);
